import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { MATERIAL_ICONS, MaterialIconPath } from 'src/app/shared/icons/material-icons';

/**
 * Icono de Material Design del widget, pintado como SVG en línea a partir de MATERIAL_ICONS.
 * No usa MatIconRegistry ni desactiva el saneado de Angular: solo enlaza el atributo `d` de cada path.
 * El tamaño y el color se controlan con clases en el host (p. ej. "w-4 h-4 text-red-600").
 */
@Component({
  selector: 'belender-icon',
  standalone: true,
  imports: [NgFor],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  /** Nombre del icono en MATERIAL_ICONS (p. ej. "close", "highlight_off"). */
  @Input() name: string;

  get paths(): MaterialIconPath[] {
    return MATERIAL_ICONS[this.name] || [];
  }
}
